<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1931 9.95356C11.8198 11.3202 9.85314 11.7402 8.12648 11.2002L4.98648 14.3336C4.75981 14.5669 4.31315 14.7069 3.99315 14.6602L2.53981 14.4602C2.05981 14.3936 1.61315 13.9402 1.53981 13.4602L1.33981 12.0069C1.29315 11.6869 1.44648 11.2402 1.66648 11.0136L4.79981 7.88023C4.26648 6.1469 4.67981 4.18023 6.05315 2.81356C8.01981 0.846895 11.2131 0.846895 13.1865 2.81356C15.1598 4.78023 15.1598 7.9869 13.1931 9.95356Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      d="M4.59314 11.6602L6.12647 13.1935"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      d="M9.66663 7.33331C10.2189 7.33331 10.6666 6.8856 10.6666 6.33331C10.6666 5.78103 10.2189 5.33331 9.66663 5.33331C9.11434 5.33331 8.66663 5.78103 8.66663 6.33331C8.66663 6.8856 9.11434 7.33331 9.66663 7.33331Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
